// extracted by mini-css-extract-plugin
export default {"pageContent":"PageContent-module__pageContent--mKesO","animatedBackground":"PageContent-module__animatedBackground--BX0Zg"};